<template>
  <div class="device-log">
    <tabs
      ref="tabs"
      :tab-list="tabs"
      default-active="DEVICE_LIST"
      @click="changeTab"
      class="tabs"
    ></tabs>
    <div class="sync" v-if="curTab === 'DEVICE_LIST'">
      <BaseButton type="primary" @click="syncDeviceList">
        同步设备列表
      </BaseButton>
      <BaseButton type="primary" @click="selectAppVisible = true">
        关联应用
      </BaseButton>
    </div>
    <device-list
      ref="deviceList"
      v-if="curTab === 'DEVICE_LIST'"
      @viewCollectData="viewCollectData"
    ></device-list>
    <collect-data ref="collectData" v-else></collect-data>
    <base-dialog show-close :visible.sync="selectAppVisible">
      <template v-slot:header>关联应用</template>
      <el-form
        :model="app"
        status-icon
        :rules="rules"
        ref="deleteInfo"
        label-width="0"
        style="margin: 30px 0;"
      >
        <el-form-item prop="appId">
          <normal-select :select-list="appList" :selected-item.sync="app.appId"></normal-select>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <span class="dialog-footer">
          <base-button @click="selectAppVisible = false">取消</base-button>
          <base-button type="primary" @click="setConfigApp">确定</base-button>
        </span>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import { tabs } from "@/views/IOT/DeviceLog/static"
import Tabs from "@/components/UIComponents/Tab"
import DeviceList from "@/views/IOT/DeviceLog/DeviceList"
import CollectData from "@/views/IOT/DeviceLog/CollectData"
import BaseButton from "@/components/UIComponents/Button"
import { syncSetting, setConfigApp, getConfigApp } from "@/api/iot/device"
import { getAppList } from "@/api/userCenter/app"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import NormalSelect from "@/components/UIComponents/NormalSelect"

export default {
  name: "DeviceLog",
  components: { NormalSelect, BaseDialog, BaseButton, CollectData, DeviceList, Tabs },
  data() {
    return {
      tabs,
      curTab: "DEVICE_LIST",
      selectAppVisible: false,
      app: {
        appId: ""
      },
      appList: [],
      rules: {
        appId: [{ required: true, message: "请选择app", trigger: "change" }]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getAppList("MEMBER").then(
        res =>
          (this.appList = res.map(app => {
            app.value = app.id
            app.label = app.name
            return app
          }))
      )
      getConfigApp().then(res => (this.app.appId = res.appId))
    },
    changeTab(key) {
      this.curTab = key
    },
    syncDeviceList() {
      syncSetting().then(res => {
        if (res.data.code === 0) {
          this.$message.success("同步设备列表成功")
        } else {
          this.$message.error("同步设备列表失败")
        }
      })
    },
    viewCollectData(deviceId) {
      this.$nextTick(() => {
        this.$refs.tabs.changeTab({
          label: "采集数据",
          value: "COLLECT_DATA"
        })
        this.$nextTick(() => this.$refs.collectData.changeDeviceId(deviceId))
      })
    },
    setConfigApp() {
      setConfigApp(this.app.appId).then(res => {
        if (res.data.code === 0) {
          this.$message.success("关联应用成功")
          this.selectAppVisible = false
        } else {
          this.$message.error("关联应用失败")
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.device-log {
  height: 100%;
  background-color: #fff;
  .tabs {
    padding: 20px 20px 10px 20px;
    ::v-deep .tab-title {
      font-size: 16px;
    }
  }
  .sync {
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
</style>
